import React from 'react';
// export const endpoint = 'https://gunadhya.tech.com/api/';
// export const origin = 'https://www.gunadhya.tech';
// export const wsorigin = 'wss://www.gunadhya.tech';
export const endpoint = process.env.NODE_ENV === 'development' ? 'http://localhost:8000' : 'https://gunadhya.tech/web';
export const origin = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://www.gunadhya.tech';
export const wsorigin = process.env.NODE_ENV === 'development' ? 'ws://localhost:8000' : 'wss://www.gunadhya.tech';
export const parseEmail = process.env.NODE_ENV === 'development' ? 'yogeshthakur3100@gmail.com' : 'amol.amlapure@gunadhyasoft.com'